import React from "react";
import "./App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Properties } from "./components/Properties";
import { Interior } from "./components/Interior";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppButton } from "./components/WhatsAppButton";

import { DataProvider } from "./context/DataContext";

function App() {
  return (
    <DataProvider>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Services />
        <Properties />
        <Interior />
        <Testimonials />
        <FAQ />
        <Contact />
        <Footer />
        <Toaster />
        <WhatsAppButton />
      </div>
    </DataProvider>
  );
}

export default App;
